import { getExtensionIdResource } from './env'

export const chromeExtensionWebStoreUrl = `https://chrome.google.com/webstore/detail/${getExtensionIdResource()}`

interface CloseTabsMessage {
  type: 'CLOSE_TABS'
  taskTitle: string | null
}

export const sendMessage = (message: CloseTabsMessage) => {
  const extensionId = getExtensionIdResource()

  return new Promise((resolve, reject) => {
    if (window.chrome?.runtime) {
      chrome.runtime.sendMessage(extensionId, message, response => {
        if (chrome.runtime.lastError) {
          reject(new Error(chrome.runtime.lastError.message))
        } else {
          resolve(response)
        }
      })
    } else {
      reject(new Error('Chrome extension is not installed or chrome.runtime is unavailable.'))
    }
  })
}
